import { Search, Search_search } from '@src/types/generated/Search';
import { Filters } from '@src/context/filterContext';
import SEARCH_QUERY from '@src/queries/search';
import { getPosition } from '@src/context/positionContext';
import { useLazyQuery } from '@apollo/client';

const defaultResult: Search_search = {
    __typename: 'SearchResult',
    cursor: null,
    filterTotal: 0,
    results: [],
};

export const useSearch = () => {
    const location = getPosition();

    const [initialSearch, { data, fetchMore, loading: isLoading }] = useLazyQuery<Search>(SEARCH_QUERY);

    const loadMore = async () => {
        await fetchMore({
            variables: {
                cursor: data.search.cursor,
            },
        });
    };

    const search = (filters: Filters, limit?: number) => {
        const params = {
            auctionSlug: filters.auctionSlug,
            category: filters.category,
            descriptionLike: filters.keyword,
            make: filters.make,
            maxYear: filters.maxYear ? Number(filters.maxYear) : undefined,
            minYear: filters.minYear ? Number(filters.minYear) : undefined,
            model: filters.model,
            sellerType: filters.sellerType,
            sortBy: filters.sortBy?.toUpperCase() || 'DISTANCE',
            sortDirection: filters.sortDirection?.toUpperCase() || 'ASC',
            subcategory: filters.subcategory,
        };

        initialSearch({
            variables: {
                limit,
                location,
                params,
            },
        });
    };

    return {
        isLoading,
        loadMore,
        result: data?.search || defaultResult,
        search,
    };
};
